<template>
    <focus-lock>
        <div class="modal-container">
            <button
                role="button"
                class="modal-close"
                aria-label="Close"
                @click="$emit('close')">
                <span class="icon icon-close" />
            </button>
            <div class="modal-body">
                <slot />
            </div>
        </div>
    </focus-lock>
</template>

<script>
import FocusLock from 'vue-focus-lock'
export default {
    name: 'modal-inner',
    components: { FocusLock },
    provide() {
        const modalOptions = {}
        Object.defineProperty(modalOptions, 'modalOpen', {
            enumerable: true,
            get: () => true,
            set: () => {
                this.$emit('close')
            }
        })
        return { modalOptions }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.modal-container

    .modal-close
        background: $white
        position: absolute
        top: 20px
        right: 20px
        padding: 6px 7px 3px
        text-align: right
        color: #333
        cursor: pointer
        content: 'Close'
        text-transform: uppercase
        font-weight: 700
        font-size: 14px
        border-width: 0px
        border-radius: 15px
        z-index: 999

        span
            font-size: 16px
            vertical-align: middle

        &:hover
            background: $dark-blue
            color: $white

    .modal-body
        padding: 20px 30px 25px

        h3
            padding: 5px 0px 5px 0px
            margin: 2px 0px 15px 0px
            font-weight: 500
            font-size: 18px
            line-height: 18px
            color: $text-dark-grey

        .el-form
            padding-top: 0px

    .modal-header
        border-bottom: 1px solid $border-color
        padding: 0px 30px
        margin-left: -30px
        margin-right: -30px
        margin-bottom: 10px

        p
            margin-top: -10px
            font-size: 14px

    .modal-footer
        text-align: right
        border-top: 1px solid $border-color
        margin-top: 25px
        padding: 15px 30px 0px
        margin-left: -30px
        margin-right: -30px
        margin-bottom: -5px
</style>
